<template>
    <div>
        <div class="card">
            <div class="card__header">
				<h4 class="card__title">Ответы на вопросы</h4>
            </div>
            <div class="card__body">
				<div class="acc">
					<AccordionItem id="payment-time">
						<template v-slot:head>
							Через сколько приходит выплата?
						</template>
						<template v-slot:body>
							Все выводы мы моментально обрабатываем и передаём платёжной системе, дальше уже зависит от них, когда они отправят вам деньги. Сначала у заявки на вывод статус "В обработке" – значит мы подали вашу заявку на вывод в платёжную систему. Затем у заявки на вывод статус "Выполнено" – значит что платежная система отправила вам деньги
							<br><br>
							Выводы на Piastrix, FKWALLET приходят моментально. Выводы на карты до в среднем минут 5 (бывают задержки несколько часов). Так же может быть статус "Выполнено", но деньги не пришли. Не волнуйтесь, через пару часов средства зачислятся.
						</template>
					</AccordionItem>

					<AccordionItem id="roleplaying">
						<template v-slot:head>
							Бонусы и вагерный баланс
						</template>
						<template v-slot:body>
							<p>
								Когда вы активируете промокод, получаете ежедневный бонус, делаете репост закрепленного поста Вконтакте или используете другие бонусы, которые увеличивают ваш баланс, вам начисляются также бонусные деньги, которые вам необходимо отыграть. Если у вас есть вагерный баланс, вы не можете вывести деньги, его необходимо отыграть. Чтобы узнать сумму бонусного баланса, вы должны перейти в настройки
								<br><br>
								Отыгрыш бонуса за регистрацию (2₽) – X10<br>
								Отыгрыш бонуса за привязку Вконтакте / Telegram (3₽) – X10<br>
								Отыгрыш бонуса за подписку на Вконтакте / Telegram (2₽) – X10<br>
								Отыгрыш бонуса за репост закрепленного поста Вконтакте (10₽) – X15<br>
								Отыгрыш ежедневного бонуса – X10<br>
								Отыгрыш бонуса за достижение нового ранга – X3<br>
								Отыгрыш кешбека – X2.5<br>
								Отыгрыш рейкбека – X1.5<br>
								Отыгрыш промокода на баланс во Вконтакте – X10<br>
								Отыгрыш промокода на баланс в Telegram – X20<br>
								Отыгрыш лотереи (если бесплатно участвуете) – X2<br>
								Отыгрыш депозита – X1.5<br>
								То есть, если вы активировали промокод на 10₽, вам необходимо сделать ставок на сумму 100₽, и только тогда вы сможете выводить (аналогично и с другими бонусами).
								<br><br>
								Если ваш баланс меньше 48₽, то при депозите весь вагерный баланс, что был на момент до депозита полностью списывается (но при депозите начисляется X1,5 от депозита в вагерный баланс).
								<br><br>
								Может произойти такая ситуация, что у вас 500₽ баланс, но до этого вы использовали много бонусов и вам надо отыграть к примеру 5000₽. Вы можете отыграть и вывести или, если проиграете, и ваш баланс станет меньше 48₽, то при следующем депозите ваш вагерный баланс полностью спишется и вы сможете выводить (после отыгрыша X1,5 от депозита).
							</p>
						</template>
					</AccordionItem>

					<AccordionItem id="wager-balance">
						<template v-slot:head>
							Отыгрыш вагерного баланса
						</template>
						<template v-slot:body>
							А. Вы можете отыграть бонусный баланс в режимах сайта:
							<br><br>
							1. Если вы не использовали бонусы при депозите или после депозита (либо немного):
							<br><br>
							В режиме dice (отыгрыш идет 1 к 1). То есть, если Вы поставили 100₽ на любой %, то вагерный баланс уменьшится на 100₽.
							<br><br>
							В режиме mines (отыгрыш идет 1 к 1). То есть, если Вы поставили 100₽ на любое количество мин, то вагерный баланс уменьшится на 100₽.
							<br><br>
							В режиме Coin (отыгрыш идёт 1 к 1). То есть, если Вы поставили 100₽ на орёл или решку, то вагерный баланс уменьшится на 100₽.
							<br><br>
							2. Если вы использовали бонусы при депозите или после депозита (много):
							<br><br>
							В режиме dice, если процент меньше 80 (отыгрыш идет 1 к 1), если процент больше 80 (отыгрыш идет 5 к 1). То есть, если Вы поставили 100₽ на 20%, то вагерный баланс уменьшится на 100₽. Если Вы поставили 100% на 90%, то вагерный баланс уменьшится на 20₽.
							<br><br>
							В режиме mines, если количество мин от 6 до 24 (отыгрыш идет 1 к 1), если мин от 2 до 5 (отыгрыш идет 5 к 1). То есть, если Вы поставили 100₽ на 7 мин, то вагерный баланс уменьшится на 100₽. Если Вы поставили 100₽ на 3 мины, то вагерный баланс уменьшится на 20₽.
							<br><br>
							В режиме Coin (отыгрыш идёт 1 к 1). То есть, если Вы поставили 100₽ на орёл или решку, то вагерный баланс уменьшится на 100₽.
							<br><br>
							Б. Вы можете отыграть бонусный баланс в слотах и live-играх:
							<br><br>
							В слотах с отметкой WAGER X1 (отыгрыш 1 к 1 при любом вагерном балансе относительно реального баланса): The Dog House, The Dog House Megaways, The Dog House Multihold, The Dog House Dice Show, The Dog House Dog or Alive, Zeus VS Hades Gods of War, Wild West Gold, Cleocatra (отыгрыш идёт 1 к 1). То есть, с вагерного баланса спишется та же сумма, которую вы поставили за спин или на которую купили бонуску.
							<br><br>
							В live-играх с пометкой WAGER X1 (отыгрыш 1 к 1 при любом вагерном балансе относительно реального баланса): Crazy Time, Funky Time, Monopoly Live, Monopoly Big Baller, Dream Catcher, Crazy Coin Flip, Mega Wheel, Sweet Bonanza CandyLand, Lightning Dice, Crazy Time A, First Person Deal or No Deal, First Person Dream Catcher, First Person Lightning Lotto, Fisrt Person Mega Ball, Gonzos Treasure Map, Gonzo's Treasure Hunt, Imperial Quest, Mega Ball, Mega Bola, Mega Bola Da Sorte, Deal Or No Deal, Boom City, Snake & Ladders Live, Vegas Ball Bonanza, Treasure Island. То есть, с вагерного баланса спишется та же сумма, которую вы поставили в конкретной live-игре.
							<br><br>
							1. Если вы не использовали бонусы при депозите или после депозита (либо немного):
							<br><br>
							В остальных слотах, если у вас маленький вагерный баланс относительно реального, которые будут с пометкой WAGER X1 (отыгрыш 1 к 1). То есть, с вагерного баланса спишется та же сумма, которую вы поставили за спин или на которую купили бонуску.
							<br><br>
							В остальных live-играх (Baccarat, Blackjack, Roulette и тд.), если у вас маленький вагерный баланс относительно реального, которые будут с пометкой WAGER X1 (отыгрыш 1 к 1). То есть, с вагерного баланса спишется та же сумма, которую вы поставили в конкретной live-игре.
							<br><br>
							2. Если вы использовали бонусы при депозите или после депозита (много):
							<br><br>
							В остальных слотах, если у вас большой вагерный баланс относительно реального, которые будут с пометкой WAGER X5 (отыгрыш 1 к 5). То есть, с вагерного баланса спишется сумма в 5 раз меньше, относительно той, которую вы поставили за спин или на которую купили бонуску. Аналогично работает со слотами с WAGER X10 и WAGER X20.
							<br><br>
							В остальных live-играх (Baccarat, Blackjack, Roulette и тд.), если у вас большой вагерный баланс относительно реального, которые будут с пометкой WAGER X0 (в них вагерный баланс вообще не отыгрывается). То есть, с вагерного баланса ничего не спишется, несмотря на ставку любой суммы в этих live-играх.
						</template>
					</AccordionItem>

					<AccordionItem id="bonus-balance-amount">
						<template v-slot:head>
							Как узнать сумму бонусного баланса?
						</template>
						<template v-slot:body>
							Чтобы узнать сумму бонусного баланса, вы должны перейти в свой профиль (там где настройки и привязка соцсетей)
						</template>
					</AccordionItem>

					<AccordionItem id="many-acc">
						<template v-slot:head>
							У меня больше 1 аккаунта. Что делать и какие будут последствия?
						</template>
						<template v-slot:body>
							Если у вас больше 1 аккаунта, вы должны нам об этом сообщить как можно скорее. Мы удалим вам лишние аккаунты и оставим 1. Все балансы, что есть на момент удаления аккаунтов, мы обнулим за нарушение правил сайта.						</template>
					</AccordionItem>

					<AccordionItem id="get-freespins">
						<template v-slot:head>
							Как получить фриспины?
						</template>
						<template v-slot:body>
							<ul>
								<li v-for="(freespin) in freespins">
									От {{ $root.currency(freespin.profit) }} минуса за неделю — {{ freespin.quantity }} спинов по {{ $root.currency(freespin.amount) }}
								</li>
							</ul>
						</template>
					</AccordionItem>

					<AccordionItem id="inactivity">
						<template v-slot:head>
							Неактивность и обнуление баланса аккаунта
						</template>
						<template v-slot:body>
							Если вы не заходили в свой аккаунт больше одного месяца, мы обнуляем ваш баланс без возможности вернуть средства
						</template>
					</AccordionItem>

					<AccordionItem id="referrals">
						<template v-slot:head>
							Что такое реферальная система?
						</template>
						<template v-slot:body>
							Реферальная система - это система вознаграждения участников за привлечение новых клиентов. Наличие этой системы позволяет Вам приводить людей по своей уникальной ссылке и получать от <strong>{{ revshare_commission_base }}%</strong> до <strong>{{ revshare_commission_max }}%</strong> от прибыли сайта с каждого реферала.
						</template>
					</AccordionItem>

					<AccordionItem id="features-referral-system">
						<template v-slot:head>
							Особенности реферальной системы
						</template>
						<template v-slot:body>
							Реферальная система на нашем сайте называется Revenue Share (сокращенно RevShare). Эта система подразумевает получение процента прибыли рефоводом от дохода сайта. Так, каждый кто рекламирует наш сайт получает от <strong>{{ revshare_commission_base }}%</strong> до <strong>{{ revshare_commission_max }}%</strong> от нашей прибыли с пользователей.<br><br>Подробнее о модели RevShare можете <a href="https://protraffic.com/baza-znaniy/model-oplaty-revshare-revshara-kak-s-nej-ra-3713.html">почитать тут</a><br><br>Формула расчета прибыли: (Депозиты – Выводы – Комиссии – Балансы)×ваш%<br><br>Комиссии считаются так: 10% с депозитов + 10% с разницы выигрышных и проигрышных ставок игроков <br><br>Avocado Manager: <a :href="$root.$link.manager">{{ $root.$link.manager_username }}</a>
						</template>
					</AccordionItem>

					<AccordionItem id="referral-not-work">
						<template v-slot:head>
							Реферал зарегистрировался по моей ссылке и не появился в списке
						</template>
						<template v-slot:body>
							Значит пользователь ранее переходил по чужой реферальной ссылке.
						</template>
					</AccordionItem>

					<AccordionItem id="incorrect-details">
						<template v-slot:head>
							Что делать, если введены неверные реквизиты?
						</template>
						<template v-slot:body>
							Если такие реквизиты не существуют в выбранной платежной системе, то средства вернутся на Ваш баланс автоматически.
						</template>
					</AccordionItem>

					<AccordionItem id="cancel-payment">
						<template v-slot:head>
							Как отменить выплату?
						</template>
						<template v-slot:body>
							Стменить созданную выплату невозможно.
						</template>
					</AccordionItem>

					<AccordionItem id="pick-up-bonuses">
						<template v-slot:head>
							Когда я смогу забрать бонусы?
						</template>
						<template v-slot:body>
							Рейкбэк – вторник<br>
							Рефералка – в любое время<br>
							Турниры – четверг (временно недоступно)<br>
							Фриспины – пятница <br>
							Большой бонус – воскресенье<br>
							Кешбэк – понедельник, четверг
						</template>
					</AccordionItem>

					<AccordionItem id="big-bonus">
						<template v-slot:head>
							Что такое Большой бонус?
						</template>
						<template v-slot:body>
							Ежедневный бонус на баланс становится больше в субботу. В среднем пользователи получают в 3 раза больше денежное вознаграждение, чем в обычный день.
						</template>
					</AccordionItem>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
	import Collapse from "../../components/blocks/Collapse.vue";
	import AccordionItem from "../../components/blocks/AccordionItem.vue";

    export default {
		components: {
			AccordionItem,
			Collapse
		},

        data() {
            return {
                revshare_commission_base: 0,
                revshare_commission_max: 70,
                freespins: []
            }
        },
        mounted() {
            this.$root.isLoading = true;

            this.getInfo()
        },
        methods: {
            getInfo() {
                this.$root.axios.get('/api/info/faq')
                    .then(res => {
                        this.revshare_commission_base = res.data.revshare_commission_base;
                        this.freespins = res.data.freespins;
                        this.$root.isLoading = false;
                    });
            }
        }
    }
</script>
